// extracted by mini-css-extract-plugin
export var dismissOverlay = "_bs-b";
export var interactivePassthrough = "_bs-3";
export var modal = "_bs-d";
export var modalBackdrop = "_bs-c";
export var modalBody = "_bs-j";
export var modalDescription = "_bs-m";
export var modalEnter = "_bs-e";
export var modalFooter = "_bs-n";
export var modalHeaderText = "_bs-h";
export var modalIconCircle = "_bs-i";
export var modalIconHeader = "_bs-g";
export var modalImage = "_bs-f";
export var modalSectionLabel = "_bs-k";
export var modalTitle = "_bs-l";
export var pulse = "_bs-1";
export var pulseBorder = "_bs-2";
export var spotlight = "_bs-0";
export var tooltip = "_bs-4";
export var tooltipButtons = "_bs-9";
export var tooltipDescription = "_bs-6";
export var tooltipFooter = "_bs-7";
export var tooltipInteractivePill = "_bs-a";
export var tooltipStepIndicator = "_bs-8";
export var tooltipTitle = "_bs-5";